import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';

import { useVariantDetailPage } from '../../../../api/hooks/useVariantDetailPage.hook';
import { VariantImage } from '../../../../api/models/variant-image';
import { VariantImageType } from '../../../../api/models/variant-image-type';
import { backend } from '../../../../utils/_config/axios';
import { LinkVariants } from '../../../../utils/_enums/link-variants.enum';
import { TypographyVariantsEnum } from '../../../../utils/_enums/typeography-variants.enum';
import { useAppSelector } from '../../../../utils/_hooks/hooks';
import useFilterAttachments from '../../../../utils/_hooks/useFilterAttachments.hook';
import { Link } from '../../../_shared/link/link';
import { Typography } from '../../../_shared/typography/typography';
import styles from './product-artifact-box.module.scss';

interface ProductArtifactBoxProps {
    isOwner?: boolean;
    instanceId?: number;
}

const ProductArtifactBox = (props: ProductArtifactBoxProps): JSX.Element => {
    const attachments = useAppSelector(state => state.productSlice.attachments);

    const data = useVariantDetailPage();

    const productArtifacts = useFilterAttachments(VariantImageType.PRODUCT_ARTIFACT, attachments);

    const [instanceArtifact, setInstanceArtifact] = useState<VariantImage[] | undefined>(undefined);

    useEffect(() => {
        if (props.instanceId) {
            (async () => {
                const res = await backend(true).get(`api/perm-attachments?instanceId.equals=${props.instanceId}`);
                setInstanceArtifact(res.data);
            })();
        }
    }, [props.instanceId]);

    if (data) {
        return (
            <div
                className={`${styles['product-artifact-box']} ${styles['downloadable-file-box']}`}
            >
                <Typography
                    className={styles['product-artifact-headline']}
                    variant={TypographyVariantsEnum.HEADING4_BOLD}
                >
                    {data.product.headlineContent}
                </Typography>

                {productArtifacts || instanceArtifact ? (
                        (productArtifacts?.[0]?.url || instanceArtifact?.[0]?.url) && props.isOwner ? (
                            <div className={styles['file-column']}>
                                <FontAwesomeIcon icon={faDownload}/>
                                <Link
                                    href={instanceArtifact?.[0]?.url ?? productArtifacts[0]?.url}
                                    className={styles['instance-detail-link']}
                                    variant={LinkVariants.STANDARD_LINK}
                                    target="_blank"
                                >
                                    {(instanceArtifact?.[0]?.url
                                        ? instanceArtifact?.[0]?.name
                                        : productArtifacts[0]?.name) ?? ''}
                                </Link>
                            </div>
                        ) : (
                            <div className={styles['product-artifact-name']}>
                                <Typography
                                    variant={TypographyVariantsEnum.MOBILENAVLINK}
                                >
                                    {productArtifacts[0]?.name}
                                </Typography>
                            </div>
                        )
                    ) :
                    null
                }

            </div>
        );
    } else {
        return <div/>;
    }
};

ProductArtifactBox.defaultProps = {
    isOwner: false
}

export default ProductArtifactBox;
